import React, { useMemo, useState } from 'react';
import clsx from 'clsx';
import debounce from 'lodash.debounce';
import { CustomModal, TextField } from '../ui';
import { exportOptions } from '../../utils/exports';
import { ListDashesIcon } from '../../icons/listDashesIcon';
import ColumnList from '../elements/columnList';
import { ExportList, ExportListMobile } from '../elements/exportList';
import { DeleteIcon, SearchIcon } from '../../icons';
import { CalendarIcon } from '../../icons/calendarIcon';
import { Calendar } from '../ui/Calendar';
import { format } from 'date-fns';

export const DownloadLogsHeaderToolBar = ({
  searchClassName,
  handleSearch = () => {},
  handleExport,
  handleColumnListClick = () => {},
  columnList = [],
  openColumnListModal,
  handleColumnSave,
  selectedColumns = [],
  dateRange = {},
  handleApplyClick,
  handleClearClick,
  handleInvoiceApplyClick,
  handleInvoiceClearClick,
  handleSearchText,
  searchText,
}) => {
  const [popoverExport, setPopoverExport] = useState(false);
  const [popoverExportMobile, setPopoverExportMobile] = useState(false);

  const [openInvoiceModal, setInvoiceModal] = useState(false);
  const [openDownloadModal, setDownloadModal] = useState(false);
  const [invoiceDate, setInvoiceDate] = useState({});
  const [downloadDate, setDownloadDate] = useState({});

  const debouncedHandleSearch = useMemo(() => {
    return debounce(handleSearch, 600);
  }, []);

  return (
    <div className={'grid lg:grid-cols-3 max-lg:gap-4'}>
      <div className="flex gap-5">
        <TextField
          wrapperClass={clsx('flex-1', searchClassName)}
          className={
            'h-full rounded-full text-body border-none items-center px-5 lg:py-4 py-3'
          }
          placeholder={'Search'}
          value={searchText}
          onChange={(e) => {
            handleSearchText(e.target.value.trim());
            //  setSearchText(e.target.value.trim());
            debouncedHandleSearch(e.target.value.trim());
          }}
          icon={<SearchIcon />}
        />
        <ExportListMobile
          isOpen={popoverExportMobile}
          exportOptions={exportOptions}
          setPopoverExport={setPopoverExportMobile}
          handleExport={(value) => {
            handleExport(value);
            setPopoverExportMobile(false);
          }}
        />
      </div>
      <div
        className={
          'flex lg:col-span-2 gap:2 lg:gap-4 lg:place-self-end max-lg:justify-between'
        }
      >
        <div className="flex gap-2 lg:hidden">
          <CustomModal
            triggerComponent={
              <div className="flex gap-1 lg:gap-2 border boder-fadedgrey rounded-full w-min items-center px-2 py-2 lg:py-3 lg:px-6">
                {downloadDate?.from || downloadDate?.to ? (
                  <DeleteIcon
                    className="h-8 w-8"
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      setDownloadDate({});
                      handleClearClick();
                    }}
                  />
                ) : (
                  <CalendarIcon className={clsx('h-4 w-4', 'stroke-black')} />
                )}
                {downloadDate?.from ? (
                  downloadDate.to ? (
                    <>
                      {format(downloadDate.from, 'dd/MM/yyyy')}-{' '}
                      {format(downloadDate.to, 'dd/MM/yyyy')}
                    </>
                  ) : (
                    format(downloadDate.from, 'dd/MM/yyyy')
                  )
                ) : (
                  <span className="label">Λήψεων</span>
                )}
              </div>
            }
            handleClick={setDownloadModal}
            openModal={openDownloadModal}
          >
            <div className="px-4 py-10 flex flex-col justify-between items-center">
              <Calendar
                initialFocus
                mode="range"
                defaultMonth={dateRange['downloadFrom']}
                selected={downloadDate}
                onSelect={(value) => {
                  setDownloadDate(value);
                }}
                numberOfMonths={1}
                className="lg:shadow-none w-full"
              />
              <div>
                <button
                  type="button"
                  className="btn-primary text-button-primary"
                  onClick={() => {
                    setDownloadModal(false);
                    handleApplyClick(downloadDate);
                  }}
                >
                  Apply
                </button>
              </div>
            </div>
          </CustomModal>

          <CustomModal
            triggerComponent={
              <div className="flex gap-1 lg:gap-2 border boder-fadedgrey rounded-full items-center w-min px-2 py-2 lg:py-3 lg:px-6">
                {invoiceDate?.from || invoiceDate?.to ? (
                  <DeleteIcon
                    className="h-8 w-8"
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      setInvoiceDate({});
                      handleInvoiceClearClick();
                      //  handleClearClick();
                    }}
                  />
                ) : (
                  <CalendarIcon className={clsx('h-4 w-4', 'stroke-black')} />
                )}

                {invoiceDate?.from ? (
                  invoiceDate.to ? (
                    <>
                      {format(invoiceDate.from, 'dd/MM/yyyy')}-{' '}
                      {format(invoiceDate.to, 'dd/MM/yyyy')}
                    </>
                  ) : (
                    format(invoiceDate.from, 'dd/MM/yyyy')
                  )
                ) : (
                  <span className="label">Παραστατικών</span>
                )}
              </div>
            }
            handleClick={setInvoiceModal}
            openModal={openInvoiceModal}
          >
            <div className="px-4 py-10 flex flex-col justify-between items-center">
              <Calendar
                initialFocus
                mode="range"
                defaultMonth={dateRange['invoicesFrom']}
                selected={invoiceDate}
                onSelect={(value) => {
                  setInvoiceDate(value);
                }}
                numberOfMonths={1}
                className="lg:shadow-none w-full"
              />
              <div>
                <button
                  type="button"
                  className="btn-primary text-button-primary"
                  onClick={() => {
                    setInvoiceModal(false);
                    handleInvoiceApplyClick(invoiceDate);
                  }}
                >
                  Apply
                </button>
              </div>
            </div>
          </CustomModal>
        </div>

        <CustomModal
          triggerComponent={
            <div className="flex gap-1 lg:gap-2 border boder-fadedgrey rounded-full px-2 py-2 lg:py-3 lg:px-6">
              <ListDashesIcon color="black" />
              <span className="label max-lg:hidden"> Visible List</span>
            </div>
          }
          handleClick={handleColumnListClick}
          openModal={openColumnListModal}
        >
          <div className="container-sm mx-aut0 10 lg:py-10 py-4 max-lg:w-full">
            <div className="flex flex-col gap-5 lg:gap-10 justify-center items-center">
              <h3>Edit Columns</h3>
              <ColumnList
                columnList={columnList}
                selectedColumns={selectedColumns}
                handleColumnSave={handleColumnSave}
                handleClose={handleColumnListClick}
              />
            </div>
          </div>
        </CustomModal>
        <ExportList
          isOpen={popoverExport}
          exportOptions={exportOptions}
          setPopoverExport={setPopoverExport}
          handleExport={(value) => {
            handleExport(value);
            setPopoverExport(false);
          }}
        />
      </div>
    </div>
  );
};
